import { useRequest, API_PATH } from '../hooks/useRequest';
/**
 * ============================================
 * C端 - 邀请任务完成接口
 * ============================================
 */
/**
 * Hook - 邀请任务完成
 * @returns 包含请求函数和状态的对象
 */
export const useQueryTaskCompleteStatus = () => {
    return useRequest(API_PATH.COMPLETE_TASK, {
        raw: true
    });
};
